import { SUBSCRIPTION, type Subscription } from '@algoacademy/backend/modules/marketplace/enums'

/** Polish VAT. Listed mentoring prices are gross. */
const VAT_RATE = 0.23

function withVat(netZloty: number): number {
  return Math.round(netZloty * (1 + VAT_RATE))
}

/** Customer-facing złoty per 4 weeks, 23% VAT already inside. */
export const GROUP_MENTORING_BASE_PRICE = withVat(399)
export const INDIVIDUAL_MENTORING_BASE_PRICE = withVat(599)
export const PROJECT_MENTORING_BASE_PRICE = withVat(4999)

export const MINIMUM_HOURS_WITH_MENTOR = 2
export const MAXIMUM_HOURS_WITH_MENTOR = 10
export const DEFAULT_HOURS_WITH_MENTOR = 2
export const PRICE_OF_ONE_HOUR_WITH_MENTOR = withVat(200)

export const MENTORING_SUBSCRIPTION_DISCOUNT_PERCENT: Record<Subscription, number> = {
  [SUBSCRIPTION.PER_4_WEEKS]: 0,
  [SUBSCRIPTION.PER_12_WEEKS]: 8,
  [SUBSCRIPTION.YEARLY]: 17
}

/** Yearly billing ≈ calendar year in 4-week units: 365 / 28. */
export const MENTORING_SUBSCRIPTION_PERIOD_COUNT: Record<Subscription, number> = {
  [SUBSCRIPTION.PER_4_WEEKS]: 1,
  [SUBSCRIPTION.PER_12_WEEKS]: 3,
  [SUBSCRIPTION.YEARLY]: 365 / 28
}

export function roundUpToNearestZloty(price: number): number {
  return Math.ceil(price)
}

export function calculateGroupMentoringPrice(): number {
  return roundUpToNearestZloty(GROUP_MENTORING_BASE_PRICE)
}

export function calculateIndividualMentoringPrice(config: { hoursWithMentor: number }): number {
  const { hoursWithMentor } = config
  const totalPrice =
    INDIVIDUAL_MENTORING_BASE_PRICE + hoursWithMentor * PRICE_OF_ONE_HOUR_WITH_MENTOR
  return roundUpToNearestZloty(totalPrice)
}

export function calculateProjectMentoringPrice(): number {
  return roundUpToNearestZloty(PROJECT_MENTORING_BASE_PRICE)
}

export function calculateMentoringSubscriptionPrice(
  basePricePerFourWeeks: number,
  subscription: Subscription
): {
  originalPrice: number
  discountedPrice: number
  savings: number
  periodsCount: number
} {
  const periodsCount = MENTORING_SUBSCRIPTION_PERIOD_COUNT[subscription]
  const originalPrice = roundUpToNearestZloty(basePricePerFourWeeks * periodsCount)
  const discountPercent = MENTORING_SUBSCRIPTION_DISCOUNT_PERCENT[subscription]
  const discountedPrice = roundUpToNearestZloty(
    originalPrice - (originalPrice * discountPercent) / 100
  )

  return {
    originalPrice,
    discountedPrice,
    savings: originalPrice - discountedPrice,
    periodsCount
  }
}
